module.exports = __webpack_public_path__ + "img/image-1.af77c9dd.png";